import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import InputPassword from 'components/UI/InputPassword';
import { useState } from 'react';
import PasswordRuleList from 'components/PasswordRuleList';
import { validatePassword } from 'utils/validatePassword';
import Switch from 'components/UI/Switch';
import { ReactComponent as FingerprintIcon } from 'assets/icons/fingerprint.svg';
import Input from 'components/UI/Input';
import { isValidEmail } from 'utils/isValidEmail';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_BIOMETRIC_SETUP } from 'constants/featureGates';
import StepHeader from './StepHeader';

const ClientPassword = ({
  literals,
  customer,
  errorEmail = false,
  onContinue,
  onEvent,
  headerStep,
  headerTotal,
}) => {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [biometric, setBiometric] = useState(false);
  const [email, setEmail] = useState('');
  // Biométrico de login solo donde hay puente nativo (app nativa). En web
  // (desktop o móvil) no existe el bridge, por eso se oculta el toggle.
  const biometricEnabled = useFeatureGate(FEATURE_BIOMETRIC_SETUP);

  const validation = validatePassword(password, repeatPassword);

  return (
    <div className='full-screen-container'>
      <div className='screen-content'>
        <StepHeader step={headerStep} total={headerTotal} onEvent={onEvent} />
        {errorEmail ? (
          <p className='font-bold text-primary mb-4 text-xl'>{literals.password.passwordCreated}</p>
        ) : (
          <>
            <p className='font-bold text-primary mb-4 text-xl'>{literals.password.createPassword}</p>
            <p className='mb-6'>{literals.password.useInApp}</p>

            <InputPassword
              name='password'
              className='mt-6'
              label={literals.password.createPassword}
              placeholder={literals.password.password}
              value={password}
              onChange={setPassword}
              required
            />
            <InputPassword
              name='repeatNewPassword'
              className='my-6'
              label={literals.password.repeatPassword}
              placeholder={literals.password.confirmPassword}
              value={repeatPassword}
              onChange={setRepeatPassword}
              required
            />
            <p className='mt-6 font-bold'>{literals.password.yourPasswordMust}</p>
            <PasswordRuleList validation={validation} />
          </>
        )}
        {!customer?.email ? (
          <div>
            <p className='mb-2 mt-6'>{errorEmail ? literals.password.continueRegistrationEmail : literals.password.yourRegistrationEmail}</p>
            <Input
              className='mb-2'
              placeholder={literals.basicInfo.email}
              autoComplete='email'
              value={email}
              onChange={(v) => setEmail(v)}
              required
            />
          </div>
        ) : null}
        {biometricEnabled && (
          <div className='flex items-center justify-between gap-6 mt-6'>
            <div className='flex items-center gap-1' onClick={() => setBiometric((prev) => !prev)}>
              <FingerprintIcon height={24} />
              <p className='mb-0'>{literals.password.linkBiometric}</p>
            </div>
            <Switch
              checked={biometric}
              onChange={(e) => setBiometric(e.target.checked)}
            />
          </div>
        )}
      </div>
      <div className='screen-actions'>
        <Button
          disabled={!validation.success || (!customer?.email && !isValidEmail(email))}
          onClick={() => onContinue({
            password,
            repeatPassword,
            biometric,
            email,
          })}
        >
          {literals.common.next}
        </Button>
      </div>
    </div>
  );
};

ClientPassword.propTypes = {
  literals: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
  errorEmail: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onEvent: PropTypes.func.isRequired,
  headerStep: PropTypes.number.isRequired,
  headerTotal: PropTypes.number.isRequired,
};

export default ClientPassword;
